import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dp_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// resolve storage-served asset paths ("/api/assets/xxx") to absolute urls;
// leave local/public paths ("/builders/..") and full urls untouched.
export const assetUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("/api/")) return `${BASE}${u}`;
  return u;
};

export function apiErr(e, fallback = "Something went wrong.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return e?.message || fallback;
}
